// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/intro-box/app/css/app.css
// module id = 595
// module chunks = 0